import {
  GetPaymentLinkRequest,
  LanguageNameSpaces,
  SubscriptionDuration,
} from "@shared/types";
import { ValueOf } from "@shared/types/utils";
import { SUBSCRIPTION_QUERY_PARAMS } from "@shared/features/settings/subscription/constants";
import { TranslationKeys } from "@shared/common/i18n/types.ts";

export const DURATION_TO_SECONDARY_DISPLAY: Record<
  SubscriptionDuration,
  TranslationKeys<LanguageNameSpaces.BILLING>
> = {
  30: "duration.monthly",
  90: "duration.quarterly",
  180: "duration.half_yearly",
  360: "duration.annually",
};

export const DURATION_TO_PRIMARY_DISPLAY: Record<
  SubscriptionDuration,
  TranslationKeys<LanguageNameSpaces.BILLING>
> = {
  30: "duration.month",
  90: "duration.quarter",
  180: "duration.half_year",
  360: "duration.year",
};

export enum BillingTab {
  CORNIX = "cornix",
  GROUPS = "groups",
}

export type SubscriptionQueryParams = ValueOf<typeof SUBSCRIPTION_QUERY_PARAMS>;

export type LocalStoragePaymentData = GetPaymentLinkRequest & {
  invoice_id: string;
  time_expires?: number;
};
